import { render, staticRenderFns } from "./SwiperInfo.vue?vue&type=template&id=79b6287b&"
import script from "./SwiperInfo.vue?vue&type=script&lang=js&"
export * from "./SwiperInfo.vue?vue&type=script&lang=js&"
import style0 from "./SwiperInfo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports